<script setup lang="ts">

import { ref, useSlots } from "vue";

type Props = { featured?: boolean }
const { featured = false } = defineProps<Props>();

const slots = useSlots() as any;
const hasSlot = ( name: string ) => !!slots[ name ];
const isExpanded = ref( false );

</script>

<template>

    <div class="rounded-2xl 
                ring-2 ring-gray-900/10 
                shadow-lg
                bg-gradient-to-b via-[4rem] 
                pb-6 3xl:pb-5"
         :class="featured ? 
            'bg-gray-750 border border-gray-650 from-gray-750/50 via-gray-800 to-gray-800 order-1' : 
            'bg-gray-800 border border-gray-900 from-gray-850/50 via-gray-850 to-gray-850/50 order-2'">

        <div class="flex flex-col px-4 3xl:px-6 pt-6 pb-4 3xl:py-7 border-b border-transparent transition-all duration-300"
             :class="{
                '!border-gray-850/75 shadow-gray-850/50 shadow-md': isExpanded == false && featured,
                '!border-gray-900/75 shadow-gray-900/30 shadow-md': isExpanded == false && featured == false
             }">
            <h1 class="tracking-wider font-bold dark:font-normal flex text-center justify-center">
                <slot name="title"></slot>
            </h1>
            <div v-if="hasSlot('sub-title')"
                 class="text-base 3xl:text-xl text-gray-400 pb-1 pt-4 3xl:pt-6">
                <slot name="sub-title"></slot>
            </div>
            
            <div v-if="hasSlot('features')">

                <div class="h-auto overflow-hidden transition-all duration-300 ease-in mt-4 -mx-3 
                            bg-gradient-to-b from-gray-600/50 via-30% via-gray-600/50 to-gray-800 rounded-t-lg 3xl:rounded-t-2xl"
                     :class="isExpanded ? '!max-h-[40rem] opacity-100' : 'max-h-0 opacity-0'">
                    <div class="text-base 3xl:text-xl pt-2 3xl:pt-4 pb-4 px-2">
                        <slot name="features" :close="() => isExpanded = false"></slot>
                    </div>
                </div>

                <!-- Expand / Collapse -->
                <div class="flex gap-1 items-center justify-center cursor-pointer px-4 z-10 text-gray-300"
                    @click.stop="() => isExpanded = !isExpanded">
                    <span class="text-xs 3xl:text-lg uppercase top-px">
                        {{ isExpanded ? 'Close' : 'More' }}
                    </span>
                    <ExpandButton v-model="isExpanded" class="pointer-events-none" />
                </div>

            </div>
            
            <div v-if="isExpanded == false" class="h-4 w-12 absolute -bottom-2 left-0 bg-gradient-to-r to-transparent" :class="featured ? 'from-gray-800' : 'from-gray-850'" />
            <div v-if="isExpanded == false" class="h-4 w-12 absolute -bottom-2 right-0 bg-gradient-to-l from-gray-800 to-transparent" :class="featured ? 'from-gray-800' : 'from-gray-850'" />
        </div>

        <div class="px-4 3xl:px-6">
            <slot></slot>
        </div>
        
    </div>

</template>
